import { watch, toValue } from "vue";
import { useAsyncData } from "@/shared/composables/useAsyncData";
import { getContactRelations } from "../infrastructure/api/contactRelationsApi";
export function useContactRelations(contactId) {
    const { data: relations, loading, loadError, load, reload } = useAsyncData(() => getContactRelations(toValue(contactId)));
    watch(() => toValue(contactId), load);
    return { relations, loading, loadError, load, reload };
}
